// import React, { useContext, useEffect, useState, useRef } from "react";
// import CheckoutContext from "../contexts/CheckoutContext";
// import { useNavigate } from "react-router-dom";
// import ProductsResume from "../components/ProductsResume";
// import DateResume from "../components/DateResume";
// import ClientDataResume from "../components/ClientDataResume";
// import DeliveryDirectionResume from "../components/DeliveryDirectionResume";
// import LoadingSpinner from "../components/LoadingSpinner";
// import WalletButton from "../components/WalletButton";
// import axios from "axios";

// function CheckoutInfo () {

//   const paymentRef = useRef(null);

//   const [launchPayment, setLaunchPayment] = useState(false);
//   const [isPreferenceCreated, setIsPreferenceCreated] = useState(false);
//   const [isLoadingMePaButton, setIsLoadingMePaButton] = useState(false);
//   const [preference, setPreference] = useState({})

//   const navigate = useNavigate();

//   const { items, deliveryDate, deliveryDirection, clientData, seller } = useContext(CheckoutContext);

//   useEffect(() => {
//     if (items.length === 0 || !clientData.name || !clientData.lastName || !clientData.phoneNumber || !clientData.email || deliveryDate.length !== 4 || Object.keys(deliveryDirection).length === 0 ) {
//         navigate("/");
//     }
//   } ,[]);

//   const handleBuy = async (e) => {
//       e.preventDefault();
//       setIsLoadingMePaButton(true);
//       setLaunchPayment(true);

//       // Delay scrolling to ensure the ref element is mounted
//       setTimeout(() => {
//         paymentRef.current?.scrollIntoView({ behavior: "smooth" });
//       }, 100); // Add a small delay to ensure rendering finishes

//       // envia request al backend para crear la preferencia
//       async function createPreference() {
//         try {
//             console.log("CREATING PREFERENCE");
//             const data = {
//               items,
//               deliveryDate,
//               deliveryDirection,
//               clientData,
//               seller,
//               quantityDiscount: process.env.REACT_APP_KILOS_NUMBER_DISCOUNT,
//               discountPercentage: process.env.REACT_APP_KILOS_NUMBER_DISCOUNT_PERCENTAGE
//             }
//             const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/create-preference`, data);
//             setPreference(response.data);
//             if (response.data.id) {
//               setIsPreferenceCreated(true);
//             }
//         } catch (error) {
//             console.log(error);
//         }
//       }
//       createPreference();
//   };

//   return(
//       <div>
//         <div className="mt-4 flex flex-col gap-2">
//           <div>
//             <DateResume deliveryDate={deliveryDate}/>
//           </div>
//           <div>
//             <DeliveryDirectionResume deliveryDirection={deliveryDirection}/>
//           </div>
//           <div>
//             <ClientDataResume clientData={clientData}/>
//           </div>
//           <div>
//             <ProductsResume items={items}/>
//           </div>
//         </div>
//         <div className="text-center mb-10 mt-4 text-white font-bold">
//             <button className="bg-gray-700 px-12 hover:bg-gray-900 w-full h-10 disabled:bg-gray-300" disabled={launchPayment} onClick={handleBuy}>IR A PAGAR</button>
//         </div>
//         <div ref={paymentRef} className="pb-[420px]">
//           {launchPayment && isPreferenceCreated ? (
//               <div>
//                   <WalletButton setIsLoadingMePaButton={setIsLoadingMePaButton} preference={preference} />
//               </div>
//           ) : null }
//           {isLoadingMePaButton ? (
//               <div className="text-center">
//                 <LoadingSpinner/>
//               </div>
//             ) : null }
//         </div>
//       </div>
//   )
// }

// export default CheckoutInfo;

// // disabled={launchPayment}


import React, { useContext, useEffect, useState, useRef } from "react";
import CheckoutContext from "../contexts/CheckoutContext";
import { useNavigate } from "react-router-dom";
import ProductsResume from "../components/ProductsResume";
import DateResume from "../components/DateResume";
import ClientDataResume from "../components/ClientDataResume";
import DeliveryDirectionResume from "../components/DeliveryDirectionResume";
import LoadingSpinner from "../components/LoadingSpinner";
import WalletButton from "../components/WalletButton";
import MainTitle from "../components/MainTitle";
import StepperBar from "../components/StepperBar";
import axios from "axios";
import { trackInitiateCheckout, trackAddPaymentInfo } from "../pixel";

function CheckoutInfo() {

    const paymentRef = useRef(null);

    const [launchPayment, setLaunchPayment] = useState(false);
    const [isPreferenceCreated, setIsPreferenceCreated] = useState(false);
    const [isLoadingMePaButton, setIsLoadingMePaButton] = useState(false);
    const [preference, setPreference] = useState({});

    const navigate = useNavigate();
    const { items, deliveryDate, deliveryDirection, clientData, seller } = useContext(CheckoutContext);

    useEffect(() => {
        if (
            items.length === 0 ||
            !clientData.name || !clientData.lastName || !clientData.phoneNumber || !clientData.email ||
            deliveryDate.length !== 4 ||
            Object.keys(deliveryDirection).length === 0
        ) {
            navigate("/");
        }
    }, []);

    const handleBuy = async (e) => {
        e.preventDefault();
        setIsLoadingMePaButton(true);
        setLaunchPayment(true);

        const subtotal = items.reduce((sum, i) => sum + i.product.currentPrice * i.quantity, 0);
        trackInitiateCheckout(subtotal, items);

        setTimeout(() => {
            paymentRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);

        try {
            const data = {
                items,
                deliveryDate,
                deliveryDirection,
                clientData,
                seller,
                quantityDiscount: process.env.REACT_APP_KILOS_NUMBER_DISCOUNT,
                discountPercentage: process.env.REACT_APP_KILOS_NUMBER_DISCOUNT_PERCENTAGE,
                freeDeliveryAmount: process.env.REACT_APP_FREE_DELIVERY_AMOUNT,
                deliveryFee: process.env.REACT_APP_DELIVERY_FEE,
            };
            const response = await axios.post(`${process.env.REACT_APP_API_URL}payment/create-preference`, data);
            setPreference(response.data);
            if (response.data.id) {
                setIsPreferenceCreated(true);
                trackAddPaymentInfo();
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="min-h-screen bg-[#fdf7ef]">

            {/* Header */}
            <MainTitle />
            <StepperBar step={6} />

            {/* Resúmenes */}
            <div className="mt-4 flex flex-col gap-3">
                <DateResume deliveryDate={deliveryDate} />
                <DeliveryDirectionResume deliveryDirection={deliveryDirection} />
                <ClientDataResume clientData={clientData} />
                <ProductsResume items={items} />
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 my-5">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">confirmar pedido</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* Botón ir a pagar */}
            <div className="px-4 mb-4">
                {!launchPayment ? (
                    <button
                        onClick={handleBuy}
                        className="w-full py-4 rounded-xl text-[15px] font-semibold bg-[#0f4a4e] hover:bg-[#155e63] active:scale-[0.98] text-[#fdf7ef] shadow-lg shadow-[#0f4a4e]/25 transition-all duration-150 flex items-center justify-center gap-2"
                    >
                        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                        </svg>
                        Ir a pagar
                    </button>
                ) : (
                    <div className="w-full py-4 rounded-xl text-[15px] font-semibold bg-gray-100 text-gray-300 text-center">
                        Procesando...
                    </div>
                )}
            </div>

            {/* Sección de pago Mercado Pago */}
            <div ref={paymentRef} className="pb-[420px]">
                {launchPayment && isPreferenceCreated && (
                    <WalletButton
                        setIsLoadingMePaButton={setIsLoadingMePaButton}
                        preference={preference}
                    />
                )}
                {isLoadingMePaButton && (
                    <div className="flex justify-center py-6">
                        <LoadingSpinner />
                    </div>
                )}
            </div>
        </div>
    );
}

export default CheckoutInfo;